import React from 'react';

const DashboardGold = () => {
  return (
    <>
      <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.666667 0H6C6.36819 0 6.66667 0.298477 6.66667 0.666667V7.33333C6.66667 7.70152 6.36819 8 6 8H0.666667C0.298477 8 0 7.70152 0 7.33333V0.666667C0 0.298477 0.298477 0 0.666667 0ZM0.666667 10.6667H6C6.36819 10.6667 6.66667 10.9651 6.66667 11.3333V15.3333C6.66667 15.7015 6.36819 16 6 16H0.666667C0.298477 16 0 15.7015 0 15.3333V11.3333C0 10.9651 0.298477 10.6667 0.666667 10.6667ZM10 5.33333H15.3333C15.7015 5.33333 16 5.03486 16 4.66667V0.666667C16 0.298477 15.7015 0 15.3333 0H10C9.63181 0 9.33333 0.298477 9.33333 0.666667V4.66667C9.33333 5.03486 9.63181 5.33333 10 5.33333ZM15.3333 16H10C9.63181 16 9.33333 15.7015 9.33333 15.3333V8.66667C9.33333 8.29848 9.63181 8 10 8H15.3333C15.7015 8 16 8.29848 16 8.66667V15.3333C16 15.7015 15.7015 16 15.3333 16Z"
          fill="url(#paint0_linear_2144_5027)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_2144_5027"
            x1={3}
            y1="-3.23169e-07"
            x2="21.5"
            y2={22}
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FFF4D1" />
            <stop offset="0.179031" stopColor="#F5D28F" />
            <stop offset={1} stopColor="#675537" />
          </linearGradient>
        </defs>
      </svg>
    </>
  );
};

export default DashboardGold;
